import React, { Component } from "react";
import { Slide } from "react-awesome-reveal";
export default class Projects extends Component {
  render() {
    return (
      <section class="portfolio" id="portfolio">
        <h2 class="heading">
          <Slide direction="down">
            <span>Projects</span>
          </Slide>
        </h2>

        <div class="portfolio-container">
          {this.props.resumeProjects?.map((project) => {
            return (
              <div>
                <div class="portfolio-box">
                  <img src={project.images[0]} alt={project.title}></img>
                  <div class="portfolio-layer">
                    <h4>{project.title}</h4>
                    <p>{project.description}</p>
                    <a href={project.url}>
                      <i class="bx bx-link-external"></i>
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}
